import { render } from "./company-comments.vue?vue&type=template&id=fe124028"
import script from "./company-comments.vue?vue&type=script&lang=js"
export * from "./company-comments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__